/*-------------------------------------------------LOGOUT----------------------------------------------------*/
export const LOGOUT = "LOGOUT";
export const LOGOUT_REINITIALIZATION = "LOGOUT_REINITIALIZATION";
/*-------------------------------------------------LOGIN----------------------------------------------------*/
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
/*-------------------------------------------------LOCAL-REFERENTIEL----------------------------------------------------*/
export const LOCAL_REFERENTIEL = "LOCAL_REFERENTIEL";
export const LOCAL_REFERENTIEL_SUCCESS = "LOCAL_REFERENTIEL_SUCCESS";
export const LOCAL_REFERENTIEL_FAIL = "LOCAL_REFERENTIEL_FAIL";
/*-------------------------------------------------GET-PACKAGE-FOR-SOUSCRIPTION---------------------------------------------------*/
export const GET_PACKAGE_FOR_SOUSCRIPTION = "GET_PACKAGE_FOR_SOUSCRIPTION";
export const GET_PACKAGE_FOR_SOUSCRIPTION_SUCCESS =
  "GET_PACKAGE_FOR_SOUSCRIPTION_SUCCESS";
export const GET_PACKAGE_FOR_SOUSCRIPTION_FAIL =
  "GET_PACKAGE_FOR_SOUSCRIPTION_FAIL";

/*-------------------------------------------------GET-SITUATION-FOR-SOUSCRIPTION---------------------------------------------------*/
export const GET_SITUATION_FOR_SOUSCRIPTION = "GET_SITUATION_FOR_SOUSCRIPTION";
export const GET_SITUATION_FOR_SOUSCRIPTION_SUCCESS =
    "GET_SITUATION_FOR_SOUSCRIPTION_SUCCESS";
export const GET_SITUATION_FOR_SOUSCRIPTION_FAIL =
    "GET_SITUATION_FOR_SOUSCRIPTION_FAIL";
/*-------------------------------------------------DETAIL-PACKAGE----------------------------------------------------*/
export const GET_DETAIL_PACKAGE = "GET_DETAIL_PACKAGE";
export const GET_DETAIL_PACKAGE_SUCCESS = "GET_DETAIL_PACKAGE_SUCCESS";
export const GET_DETAIL_PACKAGE_FAIL = "GET_DETAIL_PACKAGE_FAIL";
/*-------------------------------------------------CREATION-NOUVEAU-PACKAGE----------------------------------------------------*/
export const CREATION_NOUVEAU_PACKAGE = "CREATION_NOUVEAU_PACKAGE";
export const CREATION_NOUVEAU_PACKAGE_SUCCESS =
  "CREATION_NOUVEAU_PACKAGE_SUCCESS";
export const CREATION_NOUVEAU_PACKAGE_FAIL = "CREATION_NOUVEAU_PACKAGE_FAIL";
export const CREATION_NOUVEAU_PACKAGE_REINITIALIZATION =
  "CREATION_NOUVEAU_PACKAGE_REINITIALIZATION";
/*-------------------------------------------------MODIFICATION-PACKAGE----------------------------------------------------*/
export const MODIFICATION_PACKAGE = "MODIFICATION_PACKAGE";
export const MODIFICATION_PACKAGE_SUCCESS = "MODIFICATION_PACKAGE_SUCCESS";
export const MODIFICATION_PACKAGE_FAIL = "MODIFICATION_PACKAGE_FAIL";
export const MODIFICATION_PACKAGE_REINITIALIZATION =
  "MODIFICATION_PACKAGE_REINITIALIZATION";
/*-------------------------------------------------GET-PACKAGE-TO-MODIFY----------------------------------------------------*/
export const GET_PACKAGE_TO_MODIFY = "GET_PACKAGE_TO_MODIFY";
export const GET_PACKAGE_TO_MODIFY_SUCCESS = "GET_PACKAGE_TO_MODIFY_SUCCESS";
export const GET_PACKAGE_TO_MODIFY_FAIL = "GET_PACKAGE_TO_MODIFY_FAIL";
/*-------------------------------------------------GET-HISTORIQUE-PACKAGE----------------------------------------------------*/
export const GET_HISTORIQUE_PACKAGE = "GET_HISTORIQUE_PACKAGE";
export const GET_HISTORIQUE_PACKAGE_SUCCESS = "GET_HISTORIQUE_PACKAGE_SUCCESS";
export const GET_HISTORIQUE_PACKAGE_FAIL = "GET_HISTORIQUE_PACKAGE_FAIL";
export const GET_HISTORIQUE_PACKAGE_REINITIALIZATION =
  "GET_HISTORIQUE_PACKAGE_REINITIALIZATION";
/*-------------------------------------------------DELETE-PACKAGE----------------------------------------------------*/
export const DELETE_PACKAGE = "DELETE_PACKAGE";
export const DELETE_PACKAGE_SUCCESS = "DELETE_PACKAGE_SUCCESS";
export const DELETE_PACKAGE_FAIL = "DELETE_PACKAGE_FAIL";
export const DELETE_PACKAGE_REINITIALIZATION =
  "DELETE_PACKAGE_REINITIALIZATION";
/*-------------------------------------------------GET-CONSULTAION-PACKAGES-LIST----------------------------------------------------*/
export const GET_CONSULTATION_PACKAGES_LIST = "GET_CONSULTATION_PACKAGES_LIST";
export const GET_CONSULTATION_PACKAGES_LIST_SUCCESS =
  "GET_CONSULTATION_PACKAGES_LIST_SUCCESS";
export const GET_CONSULTATION_PACKAGES_LIST_FAIL =
  "GET_CONSULTATION_PACKAGES_LIST_FAIL";
/*-------------------------------------------------GET-CONSULTAION-TRANSACTIONS-LIST----------------------------------------------------*/
export const GET_CONSULTATION_TRANSACTIONS_LIST =
  "GET_CONSULTATION_TRANSACTIONS_LIST";
export const GET_CONSULTATION_TRANSACTIONS_LIST_SUCCESS =
  "GET_CONSULTATION_TRANSACTIONS_LIST_SUCCESS";
export const GET_CONSULTATION_TRANSACTIONS_LIST_FAIL =
  "GET_CONSULTATION_TRANSACTIONS_LIST_FAIL";
/*-------------------------------------------------ANNULATION-TRANSACTION----------------------------------------------------*/
export const ANNULATION_TRANSACTION = "ANNULATION_TRANSACTION";
export const ANNULATION_TRANSACTION_SUCCESS = "ANNULATION_TRANSACTION_SUCCESS";
export const ANNULATION_TRANSACTION_FAIL = "ANNULATION_TRANSACTION_FAIL";
export const ANNULATION_TRANSACTION_REINITIALIZATION =
  "ANNULATION_TRANSACTION_REINITIALIZATION";
/*-------------------------------------------------GENERATION-BON-COMMANDE-SOUSCRIPTION----------------------------------------------------*/
export const GENERATION_BON_COMMANDE_SOUSCRIPTION =
  "GENERATION_BON_COMMANDE_SOUSCRIPTION";
export const GENERATION_BON_COMMANDE_SOUSCRIPTION_SUCCESS =
  "GENERATION_BON_COMMANDE_SOUSCRIPTION_SUCCESS";
export const GENERATION_BON_COMMANDE_SOUSCRIPTION_FAIL =
  "GENERATION_BON_COMMANDE_SOUSCRIPTION_FAIL";
export const GENERATION_BON_COMMANDE_SOUSCRIPTION_REINITIALIZATION =
  "GENERATION_BON_COMMANDE_SOUSCRIPTION_REINITIALIZATION";
/*-------------------------------------------------GET-CONSULTAION-SOUSCRIPTIONS-LIST----------------------------------------------------*/
export const GET_CONSULTATION_SOUSCRIPTIONS_LIST =
  "GET_CONSULTATION_SOUSCRIPTIONS_LIST";
export const GET_CONSULTATION_SOUSCRIPTIONS_LIST_SUCCESS =
  "GET_CONSULTATION_SOUSCRIPTIONS_LIST_SUCCESS";
export const GET_CONSULTATION_SOUSCRIPTIONS_LIST_FAIL =
  "GET_CONSULTATION_SOUSCRIPTIONS_LIST_FAIL";
/*-------------------------------------------------GET-DETAILS-SOUSCRIPTIONS-LIST----------------------------------------------------*/
export const GET_DETAILS_SOUSCRIPTIONS = "GET_DETAILS_SOUSCRIPTIONS";
export const GET_DETAILS_SOUSCRIPTIONS_SUCCESS =
  "GET_DETAILS_SOUSCRIPTIONS_SUCCESS";
export const GET_DETAILS_SOUSCRIPTIONS_FAIL = "GET_DETAILS_SOUSCRIPTIONS_FAIL";
/*-------------------------------------------------GET-HISTORY-SOUSCRIPTIONS-LIST----------------------------------------------------*/
export const GET_HISTORY_SOUSCRIPTIONS = "GET_HISTORY_SOUSCRIPTIONS";
export const GET_HISTORY_SOUSCRIPTIONS_SUCCESS =
  "GET_HISTORY_SOUSCRIPTIONS_SUCCESS";
export const GET_HISTORY_SOUSCRIPTIONS_FAIL = "GET_HISTORY_SOUSCRIPTIONS_FAIL";

/*-------------------------------------------------MODIFICATION-SOUSCRIPTION----------------------------------------------------*/
export const MODIFICATION_SOUSCRIPTION = "MODIFICATION_SOUSCRIPTION";
export const MODIFICATION_SOUSCRIPTION_SUCCESS =
  "MODIFICATION_SOUSCRIPTION_SUCCESS";
export const MODIFICATION_SOUSCRIPTION_FAIL = "MODIFICATION_SOUSCRIPTION_FAIL";
export const MODIFICATION_SOUSCRIPTION_REINITIALIZATION =
  "MODIFICATION_SOUSCRIPTION_REINITIALIZATION";
/*-------------------------------------------------GET-SOUSCRIPTION-TO-MODIFY----------------------------------------------------*/
export const GET_SOUSCRIPTION_TO_MODIFY = "GET_SOUSCRIPTION_TO_MODIFY";
export const GET_SOUSCRIPTION_TO_MODIFY_SUCCESS =
  "GET_SOUSCRIPTION_TO_MODIFY_SUCCESS";
export const GET_SOUSCRIPTION_TO_MODIFY_FAIL =
  "GET_SOUSCRIPTION_TO_MODIFY_FAIL";

/*-------------------------------------------------EXCEL transaction-----------------------------------------------------*/
export const GENERAL_EXCEL_EXPORT = "GENERAL_EXCEL_EXPORT";
export const GENERAL_PRINT_SUCCESS = "GENERAL_PRINT_SUCCESS";
export const GENERAL_PRINT_FAIL = "GENERAL_PRINT_FAIL";
export const GENERAL_PRINT_REINITIALIZATION = "GENERAL_PRINT_REINITIALIZATION";

/*-------------------------------------------------EXCEL package-----------------------------------------------------*/
export const GENERAL_EXCEL_PACKAGE_EXPORT = "GENERAL_EXCEL_PACKAGE_EXPORT";
export const GENERAL_PRINT_PACKAGE_SUCCESS = "GENERAL_PRINT_PACKAGE_SUCCESS";
export const GENERAL_PRINT_PACKAGE_FAIL = "GENERAL_PRINT_PACKAGE_FAIL";
export const GENERAL_PRINT_PACKAGE_REINITIALIZATION =
  "GENERAL_PRINT_PACKAGE_REINITIALIZATION";
/*-------------------------------------------------EXCEL souscription-----------------------------------------------------*/
export const GENERAL_EXCEL_SOUSCRIPTION_EXPORT =
  "GENERAL_EXCEL_SOUSCRIPTION_EXPORT";
export const GENERAL_PRINT_SOUSCRIPTION_SUCCESS =
  "GENERAL_PRINT_SOUSCRIPTION_SUCCESS";
export const GENERAL_PRINT_SOUSCRIPTION_FAIL =
  "GENERAL_PRINT_SOUSCRIPTION_FAIL";
export const GENERAL_PRINT_SOUSCRIPTION_REINITIALIZATION =
  "GENERAL_PRINT_SOUSCRIPTION_REINITIALIZATION";

/************************************************CREATION-NOUVELLE-SOUSCRIPTION**************************************************************** */
export const CREATION_NOUVELLE_SOUSCRIPTION = "CREATION_NOUVELLE_SOUSCRIPTION";
export const CREATION_NOUVELLE_SOUSCRIPTION_SUCCESS =
  "CREATION_NOUVELLE_SOUSCRIPTION_SUCCESS";
export const CREATION_NOUVELLE_SOUSCRIPTION_FAIL =
  "CREATION_NOUVELLE_SOUSCRIPTION_FAIL";
export const CREATION_NOUVELLE_SOUSCRIPTION_REINITIALIZATION =
  "CREATION_NOUVELLE_SOUSCRIPTION_REINITIALIZATION";
/************************************************CONFIRMER-PAIEMENT-SOUSCRIPTION**************************************************************** */
export const CONFIRMER_PAIEMENT_SOUSCRIPTION =
  "CONFIRMER_PAIEMENT_SOUSCRIPTION";
export const CONFIRMER_PAIEMENT_SOUSCRIPTION_SUCCESS =
  "CONFIRMER_PAIEMENT_SOUSCRIPTION_SUCCESS";
export const CONFIRMER_PAIEMENT_SOUSCRIPTION_FAIL =
  "CONFIRMER_PAIEMENT_SOUSCRIPTION_FAIL";
export const CONFIRMER_PAIEMENT_SOUSCRIPTION_REINITIALIZATION =
  "CONFIRMER_PAIEMENT_SOUSCRIPTION_REINITIALIZATION";
/************************************************GET-FACTURE-SOUSCRIPTION**************************************************************** */
export const GET_FACTURE_SOUSCRIPTION = "GET_FACTURE_SOUSCRIPTION";
export const GET_FACTURE_SOUSCRIPTION_SUCCESS =
  "GET_FACTURE_SOUSCRIPTION_SUCCESS";
export const GET_FACTURE_SOUSCRIPTION_FAIL = "GET_FACTURE_SOUSCRIPTION_FAIL";
/************************************************PAIEMENT-SOUSCRIPTION**************************************************************** */
export const PAIEMENT_SOUSCRIPTION = "PAIEMENT_SOUSCRIPTION";
export const PAIEMENT_SOUSCRIPTION_SUCCESS = "PAIEMENT_SOUSCRIPTION_SUCCESS";
export const PAIEMENT_SOUSCRIPTION_FAIL = "PAIEMENT_SOUSCRIPTION_FAIL";
export const PAIEMENT_SOUSCRIPTION_REINITIALIZATION =
  "PAIEMENT_SOUSCRIPTION_REINITIALIZATION";

/************************************************EXIST_FORFAIT_AVEC_MEME_EXERCICE**************************************************************** */
export const EXIST_FORFAIT_AVEC_MEME_EXERCICE =
  "EXIST_FORFAIT_AVEC_MEME_EXERCICE";
export const EXIST_FORFAIT_AVEC_MEME_EXERCICE_SUCCESS =
  "EXIST_FORFAIT_AVEC_MEME_EXERCICE_SUCCESS";
export const EXIST_FORFAIT_AVEC_MEME_EXERCICE_FAIL =
  "EXIST_FORFAIT_AVEC_MEME_EXERCICE_FAIL";
export const EXIST_FORFAIT_AVEC_MEME_EXERCICE_REINITIALIZATION =
  "EXIST_FORFAIT_AVEC_MEME_EXERCICE_REINITIALIZATION";
/************************************************TracePaiement**************************************************************** */
export const TRACE_PAYMENT_IN_ACCOUNT = "TRACE_PAYMENT_IN_ACCOUNT";
export const TRACE_PAYMENT_IN_ACCOUNT_SUCCESS = "TRACE_PAYMENT_IN_ACCOUNT_SUCCESS";
export const TRACE_PAYMENT_IN_ACCOUNT_FAIL = "TRACE_PAYMENT_IN_ACCOUNT_FAIL";
/*******************************************MFA ********************************* */
export const SEND_OTP_MAIL = "SEND_OTP_MAIL";
export const SEND_OTP_MAIL_SUCCESS = "SEND_OTP_MAIL_SUCCESS";
export const SEND_OTP_MAIL_FAILURE = "SEND_OTP_MAIL_FAILURE";

export const REGISTER_MFA = "REGISTER_MFA";
export const REGISTER_MFA_SUCCESS = "REGISTER_MFA_SUCCESS";
export const REGISTER_MFA_FAILURE = "REGISTER_MFA_FAILURE";
